import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useFormik } from "formik";
import {
  validationSchema,
  initialValues,
} from "../../../orders/orderCartaPorte/cartaPorteConfig.js";

import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../../components/panel/panel";
import Loader from "../../../../../components/loader/index.js";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Swal from "sweetalert2";
import axiosClient from "../../../../../config/axios.js";

import {
  findFiscalRegimesByCoincidence,
  findCFDIByCoincidence,
  findPaymentFormByCoincidence,
  getFoliosBySocialReason,
  getSeriesBySocialReason,
  findCustomerSocialReasonByCoincidence,
  findPaymentMethodByCoincidence,
  getMySocialReasons,
} from "../../../../../services/CatalogService";

import {
  findPermissionTypesByCoincidence,
  findAutotransportConfigByCoincidence,
  findColoniasByPostal,
  findMunicipalitiesByState,
  findPostalCode,
  findStates,
  findClaveProdServCP,
  createCartaPorte,
  getStampFileCartaPorte,
} from "../../../../../services/CartaPorteService";

import moment from "moment-timezone";

import CartaPorteFormFields from "../../../orders/orderCartaPorte/cartaPorteFormFields.js";
import UbicacionFormFields from "../../../orders/orderCartaPorte/UbicacionFormFields.js";
import MercanciasFormFields from "../../../orders/orderCartaPorte/mercanciasFormFields.js";
import AutotransporteFormFields from "../../../orders/orderCartaPorte/autotransporteFormFields.js";
import TableConceptsCartaPorte from "../../../orders/orderCartaPorte/tableConceptsCartaPorte.js";
import FiguraOperadorFormFields from "../../../orders/orderCartaPorte/figuraOperatorFormFields.js";
import NewCustomerCartaPorte from "../../../orders/orderCartaPorte/newCustomerCartaPorte.js";
import DatatableStampedCartaPorte from "../../../orders/orderCartaPorte/datatableStampedCartaPorte.js";

import { FormikProvider } from "formik";
import { XMLParser } from "fast-xml-parser";

function AddCartaPorteFormVial() {
  const razonSocialAPI = "VaroExpress";

  const [razonSocial, setRazonSocial] = useState([""]);
  const [orden, setOrden] = useState(null); // datos de la orden vial
  const { id } = useParams();

  const [folios, setFolios] = useState([]);
  const [series, setSeries] = useState([]);

  const [conceptoFactura, setconceptoFactura] = useState("");
  const [fecha, setFecha] = useState("");
  const [selectedProductKey, setSelectedProductKey] = useState(null);
  const [insurers, setInsurers] = useState([]);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);
  const [showCartaPorteForm, setShowCartaPorteForm] = useState(true);

  const [loading, setLoading] = useState(true);
  const [lastCartaPorte, setLastCartaPorte] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const fetchLastCartaPorte = async () => {
      try {
        const response = await axiosClient.get(
          `/stamped-carta-portes/last-by-orderVial/${id}`
        );
        if (response?.data?.data) {
          setLastCartaPorte(response.data.data);
        }
      } catch (err) {
        console.error("Error al obtener carta porte:", err);
      }
    };

    if (id) {
      fetchLastCartaPorte();
    }
  }, [id]);

  const handleDownloadCartaPorte = async () => {
    try {
      const fileResponse = await getStampFileCartaPorte(
        lastCartaPorte.uuid_stamp,
        razonSocialAPI
      );

      if (fileResponse?.file?.url) {
        const link = document.createElement("a");
        link.href = fileResponse.file.url;
        link.setAttribute(
          "download",
          `${fileResponse.file.name || "CartaPorte"}.${
            fileResponse.file.extension || "pdf"
          }`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        Swal.fire(
          "Ups!",
          "No se pudo obtener el archivo de la Carta Porte",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Error", "No se pudo descargar la Carta Porte", "error");
    }
  };

  const buildCfdiObject = (values) => {
    // Genera el IdCCP con prefijo CCC
    const idCCP = "CCC" + crypto.randomUUID().slice(3);

    return {
      Version: "4.0",
      Moneda: "MXN",
      Fecha: fecha + "T00:00:00",
      Serie: values.serie,
      Folio: values.folio,
      TipoDeComprobante: "I", // ingreso
      Exportacion: "01", // no aplica exportación
      FormaPago: values.paymentMethodId.id,
      MetodoPago: values.paymentFormId.id,
      LugarExpedicion: values.customerId.socialReason.postalCode,
      lada: values.customerId.lada_phone,
      phone: values.customerId.phone,
      Receptor: {
        Rfc: values.customerId.rfc,
        Nombre: values.customerId.name,
        DomicilioFiscalReceptor: values.customerId.postalCode,
        RegimenFiscalReceptor: values.fiscalRegimeId?.id ?? "",
        UsoCFDI: values.cfdiId.id,
      },
      ObjetoImp: "02",
      Conceptos: values.conceptosFacturaTabla.map((c) => {
        const precioSinIva = parseFloat(c.precioUnitario) || 0;
        const cantidad = parseFloat(c.cantidad) || 0;

        const valorUnitarioConIva = precioSinIva * 1.16;
        const importeConIva = valorUnitarioConIva * cantidad;

        return {
          ClaveProdServ: c.productKey.productKey_idKey,
          Cantidad: cantidad.toString(),
          ClaveUnidad: c.unitKey.unitKey_idKey,
          Unidad: "Servicio",
          Descripcion: c.Descripcion,
          needRetention: c.needRetention,

          ValorUnitario: valorUnitarioConIva.toFixed(2),
          Importe: importeConIva.toFixed(2),

          Descuento: "0.00",
          ObjetoImp: "02",
        };
      }),
      Complemento: {
        Any: [
          {
            "cartaporte31:CartaPorte": {
              Version: "3.1",
              IdCCP: idCCP,
              TranspInternac: "No",
              TotalDistRec: values.DistanciaRecorrida.toString(),
              Ubicaciones: [
                {
                  TipoUbicacion: "Origen",
                  IDUbicacion: "OR000001",
                  RFCRemitenteDestinatario: values.customerId.socialReason.rfc, //remitente
                  NombreRemitenteDestinatario:
                    values.customerId.socialReason.name,
                  FechaHoraSalidaLlegada: values.fechaHoraSalidaOrigen,
                  Domicilio: {
                    Calle: values.calleOrigen,
                    Colonia: values.coloniaOrigen.c_Colonia,
                    Municipio: values.municipioOrigen.c_Municipio,
                    Estado: values.estadoOrigen.id,
                    Pais: values.paisOrigen,
                    CodigoPostal: values.codigoPostalOrigen.id,
                  },
                },
                {
                  TipoUbicacion: "Destino",
                  IDUbicacion: "DE000001",
                  RFCRemitenteDestinatario: values.customerId.rfc, //destinatario
                  NombreRemitenteDestinatario: values.customerId.name,
                  FechaHoraSalidaLlegada: values.fechaHoraLlegadaDestino,
                  DistanciaRecorrida: values.DistanciaRecorrida.toString(),
                  Domicilio: {
                    Calle: values.calleDestino,
                    Colonia: values.coloniaDestino.c_Colonia,
                    Municipio: values.municipioDestino.c_Municipio,
                    Estado: values.estadoDestino.id,
                    Pais: values.paisDestino,
                    CodigoPostal: values.codigoPostalDestino.id,
                  },
                },
              ],
              Mercancias: {
                PesoBrutoTotal: values.mercancias.PesoBrutoTotal,
                UnidadPeso: values.mercancias.UnidadPeso,
                NumTotalMercancias: values.mercancias.NumTotalMercancias,
                Mercancia: values.mercancias.Mercancia.map((m) => ({
                  BienesTransp: m.BienesTransp.id,
                  Descripcion: m.Descripcion,
                  Cantidad: m.Cantidad.toString(),
                  ClaveUnidad: m.ClaveUnidad,
                  PesoEnKg: m.PesoEnKg.toString(),
                  CantidadTransporta: m.CantidadTransporta.map((ct) => ({
                    Cantidad: ct.Cantidad.toString(),
                    IDOrigen: ct.IDOrigen,
                    IDDestino: ct.IDDestino,
                  })),
                })),
                Autotransporte: {
                  PermSCT: values.PermSCT.id,
                  NumPermisoSCT: values.NumPermisoSCT,
                  IdentificacionVehicular: {
                    ConfigVehicular: values.ConfigVehicular.id,
                    PesoBrutoVehicular: values.PesoBrutoVehicular,
                    PlacaVM: values.PlacaVM,
                    AnioModeloVM: values.AnioModeloVM.toString(),
                  },
                  Seguros: {
                    AseguraRespCivil: values.AseguraRespCivil.label,
                    PolizaRespCivil: values.PolizaRespCivil,
                  },
                  //Remolques: [], // si no hay, se manda vacío
                },
              },
              FiguraTransporte: [
                {
                  TipoFigura: values.TipoFigura,
                  NombreFigura: values.NombreFigura,
                  RFCFigura: values.RFCFigura,
                  NumLicencia: values.NumLicencia,
                },
              ],
            },
          },
        ],
      },
    };
  };

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchema,
    initialValues: initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(false);
      try {
        // lógica para guardar
        const confirmResult = await Swal.fire({
          title: "¿Estás seguro?",
          text: "¿Deseas realizar la carta porte de esta orden vial?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, realizar carta porte",
          cancelButtonText: "Cancelar",
        });

        if (!confirmResult.isConfirmed) {
          setSubmitting(false);
          return;
        }
        setSubmitting(true);

        const cfdiObject = buildCfdiObject(values);

        const data = await createCartaPorte(cfdiObject, razonSocialAPI);

        // Función para limpiar
        const cleanNumber = (value) => {
          if (!value) return 0;
          const cleaned = value.toString().replace(/[^0-9.-]+/g, "");
          return cleaned === "" ? 0 : Number(cleaned);
        };

        // Parsear XML del cfdi
        const parser = new XMLParser({
          ignoreAttributes: false,
          attributeNamePrefix: "@_",
        });

        const cfdiXml = data.cfdi.cfdi;
        const cfdiParsed = parser.parse(cfdiXml);

        // El comprobante principal
        const comprobante = cfdiParsed["cfdi:Comprobante"];

        // Subtotal y total
        const cleanSubtotal = cleanNumber(comprobante["@_SubTotal"]);
        const cleanTotal = cleanNumber(comprobante["@_Total"]);

        // Impuestos
        const impuestos = comprobante["cfdi:Impuestos"] || {};
        const traslados = impuestos["cfdi:Traslados"]?.["cfdi:Traslado"];
        const trasladoIVA = Array.isArray(traslados)
          ? traslados[0]
          : traslados || {};

        // IVA total
        const cleanIva = cleanNumber(
          impuestos["@_TotalImpuestosTrasladados"] ||
            trasladoIVA["@_Importe"] ||
            0
        );

        const retencion = cleanNumber(
          impuestos["@_TotalImpuestosRetenidos"] || 0
        );

        // Payload final: se asocia a la orden vial
        const stampedCartaPortePayload = {
          customer_name: cfdiObject.Receptor.Nombre || "SIN NOMBRE",
          customer_rfc: cfdiObject.Receptor.Rfc || "XAXX010101000",
          issued_at: moment.utc().format(),
          orderVialId: id,
          id_facturacion_cartaPorte: data.id,
          uuid_stamp: data.cfdi.uuid,
          status: data.cfdi.status || "vigente",

          total: cleanTotal,
          subtotal: cleanSubtotal,
          iva: cleanIva,
          retencion: retencion,
        };

        await axiosClient.post(
          "/stamped-carta-porte/save",
          stampedCartaPortePayload
        );

        setLastCartaPorte(stampedCartaPortePayload);
        setRefreshKey((oldKey) => oldKey + 1);

        Swal.fire({
          title: "¡Éxito!",
          text: "Carta Porte creada correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
        });
      } catch (err) {
        const errorData = err.response?.data;
        const errorMessage = Array.isArray(errorData?.message)
          ? errorData.message.join(", ")
          : errorData?.message ||
            errorData?.error ||
            "Ha ocurrido un error inesperado";

        Swal.fire({
          title: "Ups!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "Cerrar",
          showCancelButton: false,
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const localDate = moment.tz("America/Mexico_City").format("YYYY-MM-DD");
    setFecha(localDate);
    formik.setFieldValue("fecha", localDate);

    const fetchOrderVial = async () => {
      try {
        setLoading(true);

        // Obtener orden vial
        const { data: ordenData } = await axiosClient.get(`/order-vial/${id}`);

        // MercanciasFormFields y los demás sub-componentes esperan la
        // colección de vehículos en la propiedad Vehicles
        setOrden({ ...ordenData, Vehicles: ordenData.vehicles || [] });

        // Obtener aseguradoras
        const resInsurers = await axiosClient.get(`/insurers/all`);
        const insurersOptions = resInsurers.data.data.map((item) => ({
          value: item.id,
          label: item.insurance_name,
        }));
        setInsurers(insurersOptions);

        // Las ubicaciones origen/destino se capturan a mano:
        // la orden vial solo guarda texto libre (primerServDe / primerServA)

        // Autotransporte: prellenar desde la grúa asignada
        if (ordenData?.crane_id) {
          try {
            const { data: crane } = await axiosClient.get(
              `/cranes/${ordenData.crane_id}`
            );

            // Permiso SCT (autocomplete)
            if (crane.sct_permit) {
              const permisos = await findPermissionTypesByCoincidence(
                crane.sct_permit
              );
              if (permisos.length) {
                formik.setFieldValue("PermSCT", permisos[0]);
              }
            }

            // Número de permiso SCT
            formik.setFieldValue("NumPermisoSCT", crane.sct_permit_number || "");

            // Configuración vehicular (autocomplete)
            if (crane.vehicular_config) {
              const configs = await findAutotransportConfigByCoincidence(
                crane.vehicular_config
              );
              if (configs.length) {
                formik.setFieldValue("ConfigVehicular", configs[0]);
              }
            }

            // Peso bruto vehicular
            formik.setFieldValue(
              "PesoBrutoVehicular",
              crane.gross_vehicle_weight || ""
            );

            // Placa del vehículo
            formik.setFieldValue("PlacaVM", crane.plate || "");

            // Año modelo
            formik.setFieldValue("AnioModeloVM", crane.year || "");

            // Aseguradora RC (select)
            if (crane.insurance_id) {
              const aseguradoraSeleccionada = insurersOptions.find(
                (opt) => opt.value === crane.insurance_id
              );
              if (aseguradoraSeleccionada) {
                formik.setFieldValue(
                  "AseguraRespCivil",
                  aseguradoraSeleccionada
                );
              }
            }

            // Póliza de RC
            formik.setFieldValue(
              "PolizaRespCivil",
              crane.civil_liability_policy || ""
            );
          } catch (err) {
            console.error("Error al cargar la grúa de la orden vial:", err);
          }
        }

        // Figura de transporte: prellenar desde el operador asignado
        if (ordenData?.operator_id) {
          try {
            const { data: operador } = await axiosClient.get(
              `/users/${ordenData.operator_id}`
            );
            formik.setFieldValue("TipoFigura", operador.figure_type || "");
            formik.setFieldValue(
              "NombreFigura",
              `${operador.name || ""} ${operador.first_surname || ""} ${
                operador.second_surname || ""
              }`.trim()
            );
            formik.setFieldValue("RFCFigura", operador.figure_rfc || "");
            formik.setFieldValue("NumLicencia", operador.license_number || "");
          } catch (err) {
            console.error("Error al cargar el operador de la orden vial:", err);
          }
        }
      } catch (error) {
        Swal.fire("Error", "No se pudo cargar la orden vial", "error");
      } finally {
        setLoading(false);
      }
    };

    // Cargar folios, series y razones sociales
    const loadCatalogs = async () => {
      const rs = await getMySocialReasons(razonSocialAPI);
      setRazonSocial(rs);

      const foliosData = await getFoliosBySocialReason(razonSocialAPI);
      setFolios(foliosData);

      const seriesData = await getSeriesBySocialReason(razonSocialAPI);
      setSeries(seriesData);
    };

    fetchOrderVial();
    loadCatalogs();
  }, []);

  useEffect(() => {
    const customer = formik.values.customerId;

    const setCfdiAndRegime = async () => {
      if (customer && customer.cfdi && customer.fiscalRegime) {
        try {
          // Buscar CFDI por ID
          const cfdiResults = await findCFDIByCoincidence(customer.cfdi.id);
          if (cfdiResults?.length) {
            formik.setFieldValue("cfdiId", cfdiResults[0], true);
          } else {
            formik.setFieldValue("cfdiId", null, true);
          }

          // Buscar Régimen Fiscal por ID
          const regimeResults = await findFiscalRegimesByCoincidence(
            customer.fiscalRegime.id
          );
          if (regimeResults?.length) {
            formik.setFieldValue("fiscalRegimeId", regimeResults[0], true);
          } else {
            formik.setFieldValue("fiscalRegimeId", null, true);
          }
        } catch (error) {
          console.error("Error buscando cfdi/regimen:", error);
          formik.setFieldValue("cfdiId", null, true);
          formik.setFieldValue("fiscalRegimeId", null, true);
        }
      } else {
        formik.setFieldValue("cfdiId", null, true);
        formik.setFieldValue("fiscalRegimeId", null, true);
      }
    };

    setCfdiAndRegime();
  }, [formik.values.customerId]);

  const handleNewCustomerClick = () => {
    setShowCartaPorteForm(false);
    setShowNewCustomerForm(true);
  };

  if (loading || !initialValues) return <Loader isLoading={true} />;

  if (showNewCustomerForm) {
    return (
      <NewCustomerCartaPorte
        onBack={(newCustomer) => {
          setShowNewCustomerForm(false);

          if (newCustomer) {
            formik.setFieldValue("customerId", newCustomer);
          }
        }}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/facturacion-varo-express">
                Facturación Varo Express
              </Link>
            </li>
            <li className="breadcrumb-item active">Nueva Carta Porte</li>
          </ol>
          <h1 className="page-header mb-0">
            Registro de nueva Carta Porte - Folio {orden.folio}
          </h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Loader isLoading={formik.isSubmitting} />

            <Panel>
              <PanelHeader>Registro de nueva Carta Porte</PanelHeader>
              <PanelBody>
                <CartaPorteFormFields
                  formik={formik}
                  razonSocialAPI={razonSocialAPI}
                  conceptoFactura={conceptoFactura}
                  setconceptoFactura={setconceptoFactura}
                  fecha={fecha}
                  setFecha={setFecha}
                  folios={folios}
                  series={series}
                  razonSocial={razonSocial}
                  setCustomerId={(value) =>
                    formik.setFieldValue("customerId", value)
                  }
                  findPaymentFormByCoincidence={findPaymentFormByCoincidence}
                  findPaymentMethodByCoincidence={
                    findPaymentMethodByCoincidence
                  }
                  findCustomerSocialReasonByCoincidence={
                    findCustomerSocialReasonByCoincidence
                  }
                  findCFDIByCoincidence={findCFDIByCoincidence}
                  findFiscalRegimesByCoincidence={
                    findFiscalRegimesByCoincidence
                  }
                  onNewCustomerClick={handleNewCustomerClick}
                />
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Conceptos</PanelHeader>
              <PanelBody>
                <FormikProvider value={formik}>
                  <div className="my-4">
                    <div className="mb-3">
                      <TableConceptsCartaPorte
                        formik={formik}
                        selectedProductKey={selectedProductKey}
                        setSelectedProductKey={setSelectedProductKey}
                        orden={orden}
                      />
                    </div>
                  </div>
                </FormikProvider>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Ubicaciones</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  {/* Referencia de solo lectura: la orden vial no guarda
                      domicilios estructurados, el capturista debe llenar
                      las ubicaciones a mano */}
                  <div className="alert alert-info mb-3">
                    <h5 className="mb-2">
                      <i className="fa fa-circle-info me-1"></i> Referencia de
                      la orden vial
                    </h5>
                    <div>
                      <strong>Origen (primer servicio de):</strong>{" "}
                      {orden.primerServDe || "Sin registrar"}
                    </div>
                    <div>
                      <strong>Destino (primer servicio a):</strong>{" "}
                      {orden.primerServA || "Sin registrar"}
                    </div>
                    <div className="mt-2 small">
                      Captura manualmente el domicilio completo de origen y
                      destino, así como la distancia recorrida.
                    </div>
                  </div>
                  <div className="mb-3">
                    <UbicacionFormFields
                      formik={formik}
                      findColoniasByPostal={findColoniasByPostal}
                      findMunicipalitiesByState={findMunicipalitiesByState}
                      findPostalCode={findPostalCode}
                      findStates={findStates}
                      prefix="origen"
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            <Panel>
              <PanelHeader noButton>Mercancias</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <MercanciasFormFields
                      formik={formik}
                      findClaveProdServCP={findClaveProdServCP}
                      order={orden}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            <Panel>
              <PanelHeader noButton>Autotransporte</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <AutotransporteFormFields
                      formik={formik}
                      findPermissionTypesByCoincidence={
                        findPermissionTypesByCoincidence
                      }
                      findAutotransportConfigByCoincidence={
                        findAutotransportConfigByCoincidence
                      }
                      order={orden}
                      insurers={insurers}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader noButton>Figura Transporte (Operador)</PanelHeader>
              <PanelBody>
                <div className="my-4">
                  <div className="mb-3">
                    <FiguraOperadorFormFields formik={formik} order={orden} />
                  </div>
                </div>
              </PanelBody>
            </Panel>

            <Row className="mb-3">
              <Col md="12" className="d-flex justify-content-end gap-2">
                <Button type="submit" disabled={formik.isSubmitting}>
                  Guardar
                </Button>

                <Link to="/facturacion-varo-express" className="btn btn-info">
                  Cancelar
                </Link>
              </Col>
            </Row>
          </Form>
        </div>
        <Panel>
          <PanelHeader>Registro de Carta Portes</PanelHeader>
          <PanelBody>
            <Row>
              <Col md="12">
                <h3>
                  <i className="fa-solid fa-file-invoice"></i> Carta portes de
                  la orden vial{" "}
                </h3>
              </Col>
            </Row>
            <DatatableStampedCartaPorte
              razonSocialFacturacion={razonSocialAPI}
              tipoOrden="vial"
              refreshKey={refreshKey}
            />
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}

export default AddCartaPorteFormVial;
